// BookTickets/stages/DateAndTime/hooks/useTouchGuard.ts
'use client'

import { useEffect, useRef } from 'react'

function isTouchDevice(): boolean {
  return (
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (navigator as any).msMaxTouchPoints > 0)
  )
}

/**
 * Prevents “tap after scroll” on touch devices by checking the time since last touchstart.
 */
export function useTouchGuard(thresholdMs: number = 300) {
  const touchStartRef = useRef<number>(0)

  useEffect(() => {
    const handleTouchStart = () => {
      touchStartRef.current = Date.now()
    }
    window.addEventListener('touchstart', handleTouchStart)
    return () => window.removeEventListener('touchstart', handleTouchStart)
  }, [])

  function shouldIgnoreTap(): boolean {
    if (!isTouchDevice()) return false
    return Date.now() - touchStartRef.current > thresholdMs
  }

  return { shouldIgnoreTap }
}
